import { instanceApi } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import * as Types from 'types';

export const outputCsvData = (
  params: Types.OutputCsvRequest
): AxiosPromise<Types.OutputCsvResponse> => {
  const request: AxiosRequestConfig = {
    url: '/csv-output',
    method: 'POST',
    data: params,
  };
  return instanceApi(request);
};

export const downloadCsvFile = (fileName: string): AxiosPromise<Blob> => {
  const request: AxiosRequestConfig = {
    url: `/csv-output/download?fileName=${encodeURIComponent(fileName)}`,
    method: 'GET',
    responseType: 'blob',
  };
  return instanceApi(request);
};
